import {Component, OnInit, Input} from "@angular/core";
import {ApiService} from "../../../../services/api.service";
import {ActivatedRoute, Router} from "@angular/router";
import {UserService} from "../../services/users.service";
import {HttpErrorResponse} from "@angular/common/http";
import {Auth2Service} from "../../../../services/auth2.service";

@Component({
  selector: 'app-saved-searches-listing',
  templateUrl: './saved-searches-listing.component.html',
  styleUrls: ['./saved-searches-listing.component.scss'],
  standalone: false
})
export class SavedSearchesListingComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'https://www.scalanthropy.com/'},
    { label: 'Home', path: 'https://www.scalanthropy.com/'},
    { label: 'Your Dashboard', path: 'app/users/dashboard'},
    { label: 'Your Saves Searches', path: 'app/users/dashboard/saved-searches/all'}
  ];

  saveSearchTypeMap: any = {
    "DONOR_SEARCH": "lastSearchDonor",
    "GRANT_SEARCH": "lastSearchGrant",
    "NONPROFIT_SEARCH": "lastSearchNonprofit"
  }

  saveSearchTypeRouteMap: any = {
    "DONOR_SEARCH": "donors",
    "GRANT_SEARCH": "grants",
    "NONPROFIT_SEARCH": "nonprofits"
  }

  @Input()
  savedSearches: any[] = [];

  @Input()
  searchTypeName: string = '';

  @Input()
  searchTypeRoute: string = '';

  username = '';
  impersonatedEmail: any = null;
  consultantRoleName: any = null;

  constructor(private auth2ServiceChild: Auth2Service, public apiService: ApiService, private userService: UserService,
              private router: Router) {

  }

  ngOnInit() {
    // @ts-ignore
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    this.consultantRoleName = this.auth2ServiceChild.getConsultantRoleName();
  }

  onDeleteSavedSearch(savedSearch: any): void {
    this.userService.deleteSavedSearches(savedSearch.savedSearchId, this.username, this.impersonatedEmail)
      .subscribe((result:any) => {
        if (result && result.body) {
          window.location.reload();
          this.router.navigateByUrl('app/users/dashboard/saved-searches/all');
        }
      }, (err: HttpErrorResponse) => {
        if (err.status == 401) {
          this.router.navigateByUrl('app/login');
        }
        console.log('Failed to delete savedSearch: ' + savedSearch.savedSearchName);
      });
  }

  onEditSavedSearch(savedSearch: any): void {
    this.router.navigateByUrl('app/users/dashboard/saved-searches/' + this.searchTypeRoute + '/'+ savedSearch.savedSearchId + '/edit');
  }

  onViewSavedSearch(savedSearch: any): void {
    this.router.navigateByUrl('app/users/dashboard/saved-searches/' + this.searchTypeRoute + '/'+ savedSearch.savedSearchId + '/view');
  }

  onApplySavedSearch(savedSearch: any): void {
    let expirationTimestamp: number = Date.now() + 1000*3600*2;
    if (savedSearch.searchTypeDto.searchTypeName.includes("DONOR")) {
      localStorage.setItem('lastSearchDonorExpTime', expirationTimestamp.toString());
    } else if (savedSearch.searchTypeDto.searchTypeName.includes("GRANT")) {
      localStorage.setItem('lastSearchGrantExpTime', expirationTimestamp.toString());
    } else {
      localStorage.setItem('lastSearchNonprofitExpTime', expirationTimestamp.toString());
    }
    localStorage.setItem(this.saveSearchTypeMap[savedSearch.searchTypeDto.searchTypeName], savedSearch.savedSearchJson );
    this.router.navigateByUrl('app/search/' + this.saveSearchTypeRouteMap[savedSearch.searchTypeDto.searchTypeName]);
  }
}
